var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoDimensionalBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: 648,
    y: 303.5,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.3611183062824104,2.3611108039984448 L39.999999997294694,2.3611108039984448 L39.999999997294694,2.3611108039984448 C60.78738345676777,2.3611108039984448 77.63888168830808,19.21261507823535 77.63888168830808,40.00000034955059 C77.63888168830808,60.78738814696659 60.78738345676777,77.63888989510357 39.999999997294694,77.63888989510357 L2.3611183062824104,77.63888989510357 L2.3611183062824104,2.3611108039984448 z",
    stroke: "currentColor",
    transform: "rotate(180 40 40)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoDimensionalBag);
export default __webpack_public_path__ + "static/media/twoDimensionalBag.2695d1d8a065c0990e62c908edda0942.svg";
export { ForwardRef as ReactComponent };